import Add from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Dispatch, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IReducerAction } from 'views/MobileViews/About';

const thumbsContainer: any = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  width: 'fit-content',
  borderRadius: '20px',
};

const thumb: any = {
  borderWidth: '0px',
  position: 'relative',
  display: 'inline-flex',
  borderRadius: '20px',
  border: '1px solid #eaeaea',
  width: 'fit-content',
  boxSizing: 'border-box',
};

const thumbInner = {
  display: 'flex',
  minWidth: 0,
  overflow: 'hidden',
};

const img: any = {
  display: 'block',
  width: '90px',
  height: '90px',
  borderRadius: '20px',
};

const ImgageAreaBox = styled(Button)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  width: '90px',
  height: '90px',
  borderRadius: '20px',
  border: 'solid',
  borderColor: '#ffffff',
  borderWidth: '1px',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
  },
}));

interface ISmallDropZoneProps {
  dispatch: Dispatch<IReducerAction>;
}

function SmallDropZoneCard({ dispatch }: ISmallDropZoneProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [files, setFiles] = useState<any[]>([]);

  const { getRootProps, getInputProps } = useDropzone({
    accept:
      'image/jpeg,image/png,image/gif,image/svg,video/mp4,audio/mp3,audio/wav,audio/ogg',
    onDrop: acceptedFiles => {
      setIsLoaded(true);
      setFiles(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      acceptedFiles.forEach(file =>
        dispatch({ payload: { file: file }, type: 'file' })
      );
    },
  });

  const thumbs = files.map((file, index) => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <img src={file.preview} style={img} alt="" />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      files.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files]
  );

  return (
    <section className="container" style={{ position: 'relative' }}>
      {isLoaded ? (
        <CancelIcon
          onClick={() => setIsLoaded(false)}
          style={{
            position: 'absolute',
            bottom: '73px',
            left: '73px',
            zIndex: '1',
            color: '#ffffff',
          }}
        />
      ) : (
        <></>
      )}
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} />
        {isLoaded ? (
          <>
            <aside style={thumbsContainer}>{thumbs}</aside>
          </>
        ) : (
          <ImgageAreaBox
            endIcon={
              <Add
                style={{
                  fontSize: '40px',
                  color: '#36899f',
                  position: 'relative',
                  right: '5px',
                }}
              />
            }
          />
        )}
      </div>
    </section>
  );
}

export default SmallDropZoneCard;
